import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const ShowHide = ({
  isVisible = false,
  animationType = "none",
  className,
  render,
}) => {
  const baseClassName = "sal-hidable";
  const status = isVisible ? "visible" : "hidden";
  const componentClassName = classnames(
    baseClassName,
    `${baseClassName}--animation-${animationType}`,
    `${baseClassName}--${status}`,
    className,
  );
  const animationContainerClass = baseClassName + "__animation-container";

  return (
    <div className={componentClassName}>
      <div className={animationContainerClass}>{render({ isVisible })}</div>
    </div>
  );
};

ShowHide.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  animationType: PropTypes.string,
  render: PropTypes.func,
  className: PropTypes.string,
};

export default ShowHide;
